/* eslint-disable import/prefer-default-export */

import { GET_TRANSCODING_JOBS, GET_TRANSCODING_JOBS_SUCCESS, GET_TRANSCODING_JOBS_FAIL, RESET_TRANSCODING_JOBS, UPDATE_TRANSCODING_JOB } from '../constants';
import { buildQuery } from '../helpers';
export function getTranscodingJobs() {
  var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    page: 1,
    perPage: 20
  };
  var query = buildQuery(params);
  return {
    types: [GET_TRANSCODING_JOBS, GET_TRANSCODING_JOBS_SUCCESS, GET_TRANSCODING_JOBS_FAIL],
    promise: function promise(fetch) {
      return fetch("/api/transcoding_jobs?".concat(query));
    }
  };
}
export function updateJob(job) {
  return {
    type: UPDATE_TRANSCODING_JOB,
    job: job
  };
}
export function resetTranscodingJobs() {
  return {
    type: RESET_TRANSCODING_JOBS
  };
}